const updateBodyPartOptions = (
  form: HTMLFormElement,
  bodyParts: Array<{ id?: number | string; name?: string }>,
  selectedValues: Array<string> | null = null
) => {
  const formElement = form as HTMLFormElement & {
    bodyPartMultiSelect?: {
      data: Array<{ value: string; text: string }>;
      refresh: () => void;
      setValues: (values: string[]) => void;
    };
  };

  if (formElement.bodyPartMultiSelect) {
    formElement.bodyPartMultiSelect.data = bodyParts.map((bodyPart) => ({
      value: String(bodyPart.id ?? ""),
      text: bodyPart.name ?? "",
    }));

    formElement.bodyPartMultiSelect.refresh();

    if (selectedValues?.length) {
      formElement.bodyPartMultiSelect.setValues(selectedValues);
    }

    return;
  }

  const bodyPartSelect = form.querySelector<HTMLSelectElement>(
    "select[data-multi-select-init='true']"
  );

  if (!bodyPartSelect) {
    return;
  }

  bodyPartSelect.innerHTML = "";

  bodyParts.forEach((bodyPart) => {
    const option = document.createElement("option");

    option.value = String(bodyPart.id ?? "");
    option.textContent = bodyPart.name ?? "";

    if (selectedValues?.includes(option.value)) {
      option.selected = true;
    }

    bodyPartSelect.appendChild(option);
  });
};

export default updateBodyPartOptions;
